import React from "react";
import { NavLink } from "react-router-dom";

//components
import { Btn } from "../Buttons/btns";

export const links = [
  {
    path: "/",
    name: "home",
  },
  {
    path: "/diseases",
    name: "diseases",
  },
  {
    path: "/about-us",
    name: "about-us",
  },
  {
    path: "/blogs",
    name: "blogs",
  },
];

//assets
import Logo from "../../../assets/logos/logo-white.svg";
export const Navbar = ({ active ,setViewDiagnosis }) => {
  return (
    <nav className="nav pad--small">
      <div className="nav__links">
        <img src={Logo} alt="header logo" className="nav__logo" />
        {links.map((link, key) => (
          <NavLink
            to={link.path}
            className={({ isActive }) =>
              isActive ? "nav__link nav__link--active" : "nav__link"
            }
          >
            {link.name}
          </NavLink>
        ))}
      </div>
      <Btn action={() => setViewDiagnosis(true)} value="diagnosis" name="border" />
    </nav>
  );
};
